import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { DecimalOnly } from '../../../../directives/decimal-only';

@Component({
	selector: 'app-decimal-control',
	standalone: true,
	imports: [ReactiveFormsModule, NzFormModule, NzInputModule, DecimalOnly],
	templateUrl: './decimal-control.html',
	styleUrl: './decimal-control.scss',
})
export class DecimalControl {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	disabled = input<boolean>(false);
	labelSpan = input<number>(7);
	controlSpan = input<number>(12);
	min = input<number | null>(null);
	max = input<number | null>(null);
	formGroup = input.required<FormGroup>();
}
